module.exports = __webpack_public_path__ + "apple-touch-icon.620e1109.png";